export default __webpack_public_path__ + "static/media/32-SCJ.88ba1b07.jpg";